/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventDetailBookingController', DinghyEventDetailBookingController);

    DinghyEventDetailBookingController.$inject = ['$state', 'DinghyDetailBooking', 'BookingSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$stateParams', 'entity', '$http', 'Principal'];

    function DinghyEventDetailBookingController($state, DinghyDetailBooking, BookingSearch, ParseLinks, AlertService, paginationConstants, pagingParams, $stateParams, entity, $http, Principal) {

        var vm = this;

        vm.isBoard = false;
        Principal.hasAuthority('ROLE_BOARD').then(function (result) {
            vm.isBoard = result;
        });

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.dinghyEvent = entity;
        vm.dataExport = dataExport;
        vm.refresh = refresh;

        loadAll();

        function loadAll () {
            DinghyDetailBooking.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                eventId: $stateParams.id
            }, onSuccess, onError);

            // could be replaced with vm.dinghyEvent.bookedPlaces but this way it gets refreshed every time (not only with event reload)
            $http.get('api/board/dinghy-bookings/summary', {
                params: {
                    eventId: entity.id
                }
            }).then(function(response) {
                vm.status = response.data;
                vm.validPlaces = vm.status.countAngemeldet + vm.status.countWarteliste;
                vm.freePlaces = vm.dinghyEvent.placeCount - vm.validPlaces;
            });

            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.bookings = data;
                vm.page = pagingParams.page;
                //console.log(vm.bookings);
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                id: $stateParams.id
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function refresh() {
            vm.isSaving = true;
            $state.go($state.current, null, {reload: $state.current.parent});
            // loadAll();
            // vm.isSaving = false;
        }

        function dataExport() {
            vm.isSaving = true;
            $http.get('api/board/dinghy-bookings/export/', {params:{
                eventId: $stateParams.id
            }}).then(function(response) {
                vm.isSaving = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            });
        }
    }
})();
